import { PieceDoc, PieceDocPage } from '@apiContract';

export const usePiecePage = () => {
  const getActualPiecePageImage = (page: PieceDocPage) => {
    const { croppedUrl, originalUrl } = page;

    return croppedUrl || originalUrl;
  };

  const getSortedPages = (pieceDoc: PieceDoc) => {
    const { piecePages } = pieceDoc;
    if (!piecePages) return [];

    const mutablePiecePages = [...piecePages];

    return mutablePiecePages.sort((a, b) => a.sortOrder - b.sortOrder) || [];
  };

  return { getActualPiecePageImage, getSortedPages };
};
